import { createAction } from 'Helpers';
import locationTypes from './types';

const locationActions = {
	locationsListRequest: createAction(locationTypes.LIST.REQUEST),
	locationsListSuccess: createAction(locationTypes.LIST.SUCCESS),
	locationsListFailure: createAction(locationTypes.LIST.FAILURE),
	clearLocationsList: createAction(locationTypes.LIST.CLEAR),
	neshanPositionRequest: createAction(locationTypes.NESHAN_POSITION.REQUEST),
	neshanPositionSuccess: createAction(locationTypes.NESHAN_POSITION.SUCCESS),
	neshanPositionFailure: createAction(locationTypes.NESHAN_POSITION.FAILURE),
	clearNeshanPosition: createAction(locationTypes.NESHAN_POSITION.CLEAR),

	pointToAddressRequest: createAction(locationTypes.POINT_TO_ADDRESS.REQUEST),
	pointToAddressSuccess: createAction(locationTypes.POINT_TO_ADDRESS.SUCCESS),
	pointToAddressFailure: createAction(locationTypes.POINT_TO_ADDRESS.FAILURE),
	clearPointToAddress: createAction(locationTypes.POINT_TO_ADDRESS.CLEAR),
};

export default locationActions;
